export default function links() {
  const genreSettingClassName = document.querySelectorAll('.js-genre-setting');
  const genreSettingElements = Array.prototype.slice.call(genreSettingClassName, 0);
  const genreRequestClassName = document.querySelectorAll('.js-genre-request');
  const genreRequestElements = Array.prototype.slice.call(genreRequestClassName, 0);
  const pageId = 'new_bloggenre';

  const handleLinkClicked = (e) => {
    e.preventDefault();
    const url = 'https://blog.ameba.jp/ucs/bloggenre/srvgenreinput.do';
    const dataset = e.currentTarget.dataset;
    const { tapId = '', orderId = '', bloggerAmebaId = '' } = dataset;
    const contentIds = dataset.contentIds
      ? dataset.contentIds.replace(/'/g, '"')
      : '';

    const obj = {
      event: 'tapTrigger',
      commonPage_pageId: pageId,
      contents_tapId: tapId,
      contents_orderId: orderId,
      contents_contentIds: contentIds,
      contents_bloggerAmebaId: bloggerAmebaId,
    };

    window.dataLayer.push(obj);

    return window.open(url);
  }

  const handleRequestClicked = (e) => {
    e.preventDefault();
    const url = 'https://docs.google.com/forms/d/e/1FAIpQLSefzymL_0vVVlxablSSLeXPiLSLjq_Y-hllod_80ZMOGTfyCA/viewform';

    const dataset = e.currentTarget.dataset;
    const { tapId = "", orderId = "", bloggerAmebaId = "" } = dataset;
    const contentIds = dataset.contentIds
      ? dataset.contentIds.replace(/'/g, '"')
      : "";

    const obj = {
      event: "tapTrigger",
      commonPage_pageId: pageId,
      contents_tapId: tapId,
      contents_orderId: orderId,
      contents_contentIds: contentIds,
      contents_bloggerAmebaId: bloggerAmebaId,
    };

    window.dataLayer.push(obj);

    return window.open(url);
  };

  genreSettingElements.forEach(function (element) {
    element.addEventListener('click', handleLinkClicked, 'test');
  });

  genreRequestElements.forEach(function (element) {
    element.addEventListener('click', handleRequestClicked);
  });
}

links();
